<template>
    <b-nav-item-dropdown class="align-selfdrop-down lang-drop-down">
        <template #button-content>
            <img class="LogoSmall3-count-img" :src="flags[$i18n.locale]" :alt="$i18n.locale" />
        </template>
        <b-dropdown-item class="cust-list-item" v-for="locale in locales" :key="`locale-${locale.code}`" @click.prevent="$switchLocalePath(locale.code)" exact :link-class="{ 'active': $i18n.locale === locale.code }">
            <img class="LogoSmall3-count-img" :src="flags[locale.code]" :alt="locale.code" />
            <div>{{ $t(locale.code) }}</div>
        </b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
import fr from 'svg-country-flags/svg/fr.svg'
import us from 'svg-country-flags/svg/us.svg'
export default {
    data() {
        return {
            locales: [{
                    code: 'fr',
                    iso: 'fr-FR'
                },
                // {
                //     code: 'en',
                //     iso: 'en-US'
                // }
            ],
            flags: {
                fr,
                en: us
            }
        };
    },
    methods: {
        $switchLocalePath(locale) {
            try {
                this.$router.push(this.switchLocalePath(locale))
            } catch (e) {
                this.$root.$i18n.locale = locale
            }
        }
    }
}
</script>
